<template>
  <Dialog v-model:visible="visible"
    :modal="true"
    position="center"
    :contentStyle="{'overflow': 'scrollable'}"
    ref="dialog" @show="onDialogShow"
    :style="{ maxHeight: '90vh', overflow: 'scrollable'}"
    >
    <template #header>
      <h2>Импортиране</h2>
    </template>
    <div class="border-layout" style="width: 1200px">
      <div class="north">
        <div class="p-fluid p-grid">
          <div class="p-field p-col-12 p-md-3">
            <label for="category">CSV Файл</label>
            <input type="file" ref="file" name="files" @change="fileHandler"/>
          </div>
          <div class="p-field p-col-12 p-md-3" v-if="importedData.header.length > 0">
            <label for="selected">Продуктов номер</label>
            <Dropdown v-model="productKey" :options="importedData.header" optionLabel="value" optionValue="key"
              placeholder="Колона, съдържаща продуктов номер" @change="onProductKeyChange"/>
          </div>
          <div class="p-field p-col-12 p-md-3" v-if="importedData.header.length > 0">
            <label for="quantity">Количество</label>
            <Dropdown v-model="quantity" :options="importedData.header" optionLabel="value" optionValue="key"/>
          </div>
          <div class="p-field p-col-12 p-md-3" v-if="importedData.header.length > 0">
            <label for="price">Цена</label>
            <Dropdown v-model="price" :options="importedData.header" optionLabel="value" optionValue="key"/>
          </div>
        </div>
      </div>
      <div class="center import-1" v-if="importedData.header.length > 0">
        <h3>Импортирани данни</h3>
        <DataTable :value="importedData.lines" :rowclass="rowClass"
          style="height: calc(100vh - 410px)"
          :scrollable="true" scrollHeight="flex" class="p-datatable-gridlines p-datatable-striped p-datatable-sm center">
          <Column header="Код" style="flex: 0 0 7em">
            <template #body="props">
              {{itemNumber(props.data)}}&nbsp;
            </template>
          </Column>
          <Column header="Наименование" style="flex-grow: 4000">
            <template #body="props">
              {{itemName(props.data)}}
            </template>
          </Column>
          <Column header="К-во" style="flex: 0 0 4em" bodyClass="right">
            <template #body="props">
              {{itemQuantity(props.data)}}
            </template>
          </Column>
          <Column header="Ед. цена" style="flex: 0 0 6em" bodyClass="right">
            <template #body="props">
              {{$utils.currency(itemPrice(props.data), 4)}}
            </template>
          </Column>
          <Column header="Стойност" style="flex: 0 0 7em" bodyClass="right">
            <template #body="props">
              {{$utils.currency(itemNetto(props.data))}}
            </template>
            <template #footer>
              {{$utils.currency(netto)}}
            </template>
          </Column>
        </DataTable>
      </div>
    </div>

    <template #footer>
      <ButtonsApplyCancel @apply="onImport" @cancel="$refs.dialog.close()" labelOk="Импорт"/>
    </template>
  </Dialog>

</template>

<script>
export default {
  inheritAttrs: false,
  emits: {
    close: null,
    import: null
  },
  data() {
    return {
      visible: false,
      productKey: null,
      quantity: null,
      price: null,
      importedData: {
        header: [],
        lines: []
      },
      products: {},
      items: [],
      textResult: "",
      files: [],
      data: {}
    }
  },

  created() {
  },

  props: {
    title: String,
    selected: Object
  },

  methods: {
    onDialogShow() {
      this.productKey = null;
      this.quantity = null;
      this.price = null;
      this.importedData = {
        header: [],
        lines: []
      };
      this.products = {};
    },
    onProductKeyChange() {
      var ids = [];
      for (var line of this.importedData.lines) {
        var s = this.itemNumber(line);
        if (s != null) {
          ids.push(s);
        }
      }
      var ctx = this;
      this.$http.post('/product/numbers-map', {numbers: ids})
            .then(function(res) {
              ctx.products = res.data;
            }).catch(function() {
              ctx.products = {};
            });
    },
    shouldAccept(line) {
      if (this.itemPriceWholesale(line) == null || this.itemPriceRetail(line) ==  null) {
        return false;
      }
      return this.itemNumber(line) &&  this.itemCondition(line)
    },
    loadCsvFile(fileToRead) {
      var ctx = this;
      var reader = new FileReader();
      // Handle errors load
      var processData = function(csv) {
        ctx.importedData = {
          header: [],
          lines: []
        }
        var lines = csv.split(/\r\n|\n/);
        for (var line of lines) {
          ctx.importedData.lines.push(line.split(";"))
        }
        if (ctx.importedData.lines.length > 0) {
          ctx.importedData.header = ctx.importedData.lines[0]
          var header = [];
          for (var i = 0; i < ctx.importedData.header.length; i++) {
            header.push({
              key: i,
              value: ctx.importedData.header[i]// + ' (' + (i + 1) + ')'
            });
          }
          ctx.importedData.header = header;
          ctx.importedData.lines.shift();
        }
      };
      reader.onload = function(event) {
        var csv = event.target.result;
        processData(csv);
      };
      reader.onerror = function(evt) {
        if(evt.target.error.name == "NotReadableError") {
          alert("Canno't read file !");
        }
      }
      // Read file into memory as UTF-8
      reader.readAsText(fileToRead);
    },
    fileHandler() {
      var file = this.$refs.file.files[0];
      // Check for the various File API support.
      if (window.FileReader) {
          // FileReader are supported.
          this.loadCsvFile(file);
      } else {
          alert('FileReader is not supported in this browser.');
      }
    },
    onImport() {
      var n = this.netto;
      if(n == null || n <= 0) {
        alert("Няма събрани данни")
      }
      var items = [];
      for (var line of this.importedData.lines) {
        var item = {
          quantity : this.itemQuantity(line),
          price : this.itemPrice(line)
        };
        var number = this.itemNumber(line);
        item.product = this.products[number];
        if ( !number || !item.price || !item.product || !item.quantity) {
          continue;
        }
        items.push(item);
      }
      this.$emit('import', items);
    },
    trimString(s, r, repl) {
      if (s) {
        s = s.trim();
        if (r != undefined && repl != undefined) {
          s = s.replace(r, repl);
        }
        return s;
      }
      return "";
    },
    open() {
      this.visible = true;
    },
    itemNumber(item) {
      if (Number.isInteger(this.productKey)) {
        return this.trimString(item[Number(this.productKey)])
      }
      return null;
    },
    itemName(item) {
      var number = this.itemNumber(item);
      if (number) {
        var product = this.products[number];
        if (product && product.name) {
          return product.name;
        }
      }
      return null;
    },
    itemQuantity(item) {
      if (Number.isInteger(this.quantity)) {
        return this.trimString(item[Number(this.quantity)], ",", ".")
      }
      return null;
    },
    itemPrice(item) {
      if (Number.isInteger(this.price)) {
        return this.trimString(item[Number(this.price)], ",", ".")
      }
      return null;
    },
    itemNetto(item) {
      var quantity = this.itemQuantity(item);
      if (isNaN(quantity)) {
        return null;
      }
      var price = this.itemPrice(item);
      if (isNaN(price)) {
        return null;
      }
      return quantity * price;
    },
    rowClass(item) {
      var v = this.itemNetto(item);
      if (isNaN(v)) {
        return 'error';
      }
      return null;
    }
  },

  computed: {
    imported: {
      get() {
        return this.lines;
      },
      set(newValue) {
        this.lines = newValue;
      }
    },
    netto() {
      var total = 0.0;
      for (var line of this.importedData.lines) {
        var value = this.itemNetto(line);
        if (value != null) {
          total += value;
        }
      }
      return total;
    }
  }
}
</script>

<style>
    .import-1 .p-datatable-scrollable-body {
      max-height: 180px !important;
    }
    .import-1 .error {
      background-color: red;
      color: white;
    }
</style>
